import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Plan roczny',
  type: 'object',
  properties: {
    year: {
      title: 'Rok szkolny',
      type: 'number',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
